// src/features/template/components/TemplateForm.tsx
import React from 'react';
import {
  Grid,
  TextField,
} from '@mui/material';
import { TemplateForm as ITemplateForm, ValidationErrors } from '../types/index';

interface Props {
  form: ITemplateForm;
  errors: ValidationErrors;  // Updated this line
  onChange: (field: keyof ITemplateForm, value: any) => void;
}

const commonInputStyles = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#1B2B3A',
    borderRadius: '8px',
    color: 'white',
    '& fieldset': {
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '8px'
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.3)'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#00A4E0'
    }
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.7)',
    '&.Mui-focused': {
      color: '#00A4E0'
    },
    '&.MuiInputLabel-shrink': {
      background: 'linear-gradient(to bottom, transparent 0%, #243B53 45%, #243B53 100%)',
      paddingRight: '8px',
      paddingLeft: '8px',
      marginTop: '1px'
    }
  },
  '& .MuiFormHelperText-root': {
    color: 'rgba(255, 82, 82, 0.87)',
    marginLeft: 0,
    marginTop: '6px'
  }
};

export const TemplateForm: React.FC<Props> = ({ form, errors, onChange }) => {
  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} md={6}>
        <TextField 
          fullWidth 
          label="From" 
          variant="outlined"
          value={form.from}
          onChange={(e) => onChange('from', e.target.value)}
          error={!!errors.from}
          helperText={errors.from}
          placeholder="Display Name <email@domain>"
          sx={commonInputStyles}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField 
          fullWidth 
          label="Subject" 
          variant="outlined"
          value={form.subject}
          onChange={(e) => onChange('subject', e.target.value)}
          error={!!errors.subject}
          helperText={errors.subject}
          sx={commonInputStyles}
        />
      </Grid>
    </Grid>
  );
};
